<button (click)="onClick()" mat-button type="button" style="line-height: 24px;"><mat-icon class="iconsize-20 mat-icon material-icons">{{icon}}</mat-icon></button>


// WEBPACK FOOTER //
// ./src/app/shared/grid/buttons/header-button.component.ts.HeaderButtonComponent.html